import React from 'react';
import { SplitPaneTemplate } from 'components';
import { CtTag, CtTarget, CtTargetDetail } from 'containers';

import styles from './TargetLayout.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

// 비활성화 계정 체크
const TargetLayout = ({ isDetailView }) => {
  return (
    <div className={cx('targetLayout-wrapper')}>
      <div className={cx('list-area')}>
        <CtTag />
      </div>
      <div className={cx('content-area', { 'hide-Detail': !isDetailView })}>
        <SplitPaneTemplate listData={<CtTarget />} detail={<CtTargetDetail />} />
      </div>
    </div>
  );
};

export default TargetLayout;



// WEBPACK FOOTER //
// ./src/script/components/target/TargetLayout.js